export default __webpack_public_path__ + "static/media/chelseaDavenportPic@4x.af8e8783.png";